import Model from './Model';

export default class Payment extends Model {
    static SUBSCRIPTION_REGULAR_PAYMENT_SOURCE = 1;
    static SUBSCRIPTION_3X_PAYMENT_SOURCE = 2;
    static FINALIZATION_PAYMENT_SOURCE = 3;
}
